import React from 'react';
import { List } from 'immutable';
import c from 'classnames';

import {
  WysiwygField, Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Slider from '../../../components/Slider';

import {
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
  PARAGRAPH_VIEW_MODE_DEFAULT,
} from '../../../config/constants';

import './style.scss';

const ParagraphContentSlider = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT }) => {
  const viewModeIsFullscreen = viewMode === PARAGRAPH_VIEW_MODE_FULLSCREEN;

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const entities = entity.get('field_content_slider_items', List());

  const paragraphClassNames = c('ParagraphContentSlider', { 'active-theme-background-color': viewModeIsFullscreen });
  const contentColumnClassNames = viewModeIsFullscreen ? 'col-12 col-lg-8' : 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2';

  return (
    <div className={paragraphClassNames}>
      <div className={`${viewModeIsFullscreen && 'Fullscreen'}`}>
        <div className={`${viewModeIsFullscreen && 'Fullscreen__content-centered'}`}>
          {(text || title) && (
            <div className="ParagraphContentSlider__content">
              <Container>
                <div className="row">
                  <div className={contentColumnClassNames}>
                    {title && (
                      <div className="ParagraphContentSlider__textBox__title">
                        <h2>{title}</h2>
                      </div>
                    )}

                    {text && (
                      <div className="ParagraphContentSlider__textBox__text">
                        <WysiwygField
                          property="schema:text"
                          html={text}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Container>
            </div>
          )}

          <div className="ParagraphContentSlider__slider">
            <Slider items={entities} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParagraphContentSlider;
